import React from "react";
import Slider from "react-slick";
import Image from "next/image";
import Link from "next/link";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import {
  CardWrapper,
  SliderWrapper,
  Rating,
  StarIcon,
  BottomBox,
  Title,
  TopBox,
  Tags,
  TagBox,
  RecipeItemContainer,
  ImageWrapper,
  Chip,
  ChipText,
  BottomTextContainer,
  RecipeTitle,
  CookingTimeAndIngredientsContainer,
  TopContainer2,
} from "./style";
import { FlexDiv } from "@/components/Atoms";
import theme from "@/foundation/Theme";

function SimilarRecipeSlider(props: any) {
  const { data = [], setShowModal = () => {} } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3.5,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.25,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1.25,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const FullStar = () => (
    <StyledSvgSprite
      icon="icon-star-fill"
      fill={theme.colorsV2.warning.shade_400}
      stroke={theme.colorsV2.warning.shade_400}
      height="16px"
      width="16px"
    />
  );
  return (
    <SliderWrapper maxWidth={"100%"}>
      <Slider {...settings}>
        {(data || []).map((data: any, index: number) => {
          const {
            cover_image: coverImage,
            title,
            cooking_time: cookingTime,
            ingredient_count: ingredientsCount,
            default_rating: rating,
            isFavorite = true,
            slug,
            shareUrl,
          } = data || {};

          return (
            <RecipeItemContainer>
              <ImageWrapper>
                <Image src={coverImage} fill alt={title} />
              </ImageWrapper>
              <TopContainer2>
                <Chip>
                  <FullStar />
                  <ChipText variant="label1" fontFamily="var(--man-700)">
                    {rating}
                  </ChipText>
                </Chip>

                <FlexDiv
                  height="24px"
                  width="24px"
                  borderRadius="50%"
                  justifyContent="center"
                  alignItems="center"
                  bg={isFavorite ? "#F04438" : "rgba(255,255,255,0.4)"}
                >
                  <StyledSvgSprite
                    icon="icon-ixon-heart"
                    fill={isFavorite ? "#ffffff" : "#98A2B3"}
                    height="11px"
                    width="12.5px"
                  />
                </FlexDiv>
              </TopContainer2>
              <BottomTextContainer>
                <h2 style={{ margin: 0 }}>
                  <RecipeTitle variant="span" fontFamily="var(--man-700)">
                    {title}
                  </RecipeTitle>
                </h2>
                <CookingTimeAndIngredientsContainer>
                  <Chip>
                    <ChipText
                      variant="label3"
                      fontFamily="var(--man-700)"
                    >{`${cookingTime} minutes`}</ChipText>
                  </Chip>
                  <Chip>
                    <ChipText
                      variant="label3"
                      fontFamily="var(--man-700)"
                    >{`${ingredientsCount} Ingredients`}</ChipText>
                  </Chip>
                </CookingTimeAndIngredientsContainer>
              </BottomTextContainer>
            </RecipeItemContainer>
          );
        })}
      </Slider>
    </SliderWrapper>
  );
}

export default SimilarRecipeSlider;
